import styles from './BillingToggle.module.css';

// Shared Annual/Monthly toggle used by the Pricing page and the homepage pricing
// preview so both stay visually identical. Self-centers; pass `className` for spacing.
//
// `savingLabel` is passed in rather than hardcoded. It used to read "save 17%", which was
// simply wrong: annual is ~31% off monthly ($490 against 12 x $59). A number baked into a
// shared toggle cannot track the prices it describes, so the caller computes it from the
// live catalogue and this component just renders it.
export default function BillingToggle({ billing, onChange, className = '', savingLabel = null }) {
  return (
    <div className={`${styles.wrap} ${className}`}>
      <div className={styles.toggle} role="group" aria-label="Billing period">
        <button
          className={`${styles.toggleBtn} ${billing === 'monthly' ? styles.toggleActive : ''}`}
          onClick={() => onChange('monthly')}
          aria-pressed={billing === 'monthly'}
        >
          Monthly
        </button>
        <button
          className={`${styles.toggleBtn} ${billing === 'annual' ? styles.toggleActive : ''}`}
          onClick={() => onChange('annual')}
          aria-pressed={billing === 'annual'}
        >
          Annual{savingLabel ? <span className={styles.save}>{savingLabel}</span> : null}
        </button>
      </div>
    </div>
  );
}
